export const CreatePayerSetupWizardLink = (locationId: string | number, carrierNameId: string | number, pageId: number) => {
  const url = new URL(window.location.origin)
  url.pathname = '/settings/application-settings/insurance-verifications';
  url.searchParams.set('ivLocationId', locationId.toString());
  url.searchParams.set('ivCarrierNameId', carrierNameId.toString());
  url.searchParams.set('ivWizardPage', pageId.toString());

  return { pathname: url.pathname, search: url.search };
}

export const CreateProviderSetupTabLink = (locationId: string | number, tabId: number) => {
  const url = new URL(window.location.origin)
  url.pathname = '/settings/application-settings/insurance-verifications';
  url.searchParams.set('ivLocationId', locationId.toString());
  url.searchParams.set('ivTabId', tabId.toString());

  return { pathname: url.pathname, search: url.search };
}